// Deep Module: Simple interface hiding all HTTP complexity.
// Consumers call `api.get<T>()` and `api.put<T>()` — zero knowledge of fetch, headers, or error handling.

// In dev, use Vite proxy (relative paths). In production, use the deployed Worker.
const BASE_URL = import.meta.env.DEV ? "" : "https://garment-api.jlzagogue.workers.dev";

type ApiResponse<T> = { data: T; error?: never } | { data?: never; error: string };

async function request<T>(
  method: string,
  path: string,
  body?: unknown
): Promise<ApiResponse<T>> {
  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      method,
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });

    if (!res.ok) {
      return { error: `Error ${res.status}: ${res.statusText}` };
    }

    const data = (await res.json()) as T;
    return { data };
  } catch (e) {
    return { error: e instanceof Error ? e.message : "Network error" };
  }
}

export const api = {
  get: <T>(path: string) => request<T>("GET", path),
  put: <T>(path: string, body: unknown) => request<T>("PUT", path, body),
  post: <T>(path: string, body: unknown) => request<T>("POST", path, body),
  del: <T>(path: string) => request<T>("DELETE", path),
};
